<video controls autoplay>
  <source [src]="videoSrc" type="video/mp4" />
</video>
